import { render, staticRenderFns } from "./Comercial.vue?vue&type=template&id=32a7b015&"
import script from "./Comercial.vue?vue&type=script&lang=js&"
export * from "./Comercial.vue?vue&type=script&lang=js&"
import style0 from "./Comercial.vue?vue&type=style&index=0&lang=css&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports